var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7667_3038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C7.32898 20 4.81773 18.9596 2.92904 17.071C1.04035 15.1823 0 12.671 0 10C0 7.32898 1.04035 4.81773 2.92904 2.92904C4.81773 1.04035 7.32898 0 10 0C12.671 0 15.1823 1.04035 17.071 2.92904C18.9596 4.81773 20 7.32898 20 10C20 12.671 18.96 15.1823 17.071 17.071C15.1823 18.9596 12.671 20 10 20ZM10 1.23275C7.65827 1.23275 5.45642 2.14484 3.80063 3.80063C2.14484 5.45642 1.23275 7.65827 1.23275 10C1.23275 12.3417 2.14484 14.5436 3.80063 16.1994C5.45642 17.8552 7.65827 18.7673 10 18.7673C12.3417 18.7673 14.5436 17.8552 16.1994 16.1994C17.8552 14.5436 18.7673 12.3417 18.7673 10C18.7673 7.65827 17.8552 5.45642 16.1994 3.80063C14.5436 2.14484 12.3417 1.23275 10 1.23275Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1622 11.492V13.237C14.1622 14.1498 13.426 14.8977 12.5132 14.8995C12.5076 14.8995 12.5016 14.8995 12.496 14.8995C11.864 14.8995 11.2501 14.8204 10.6643 14.6708C8.05176 14.0051 5.99505 11.9484 5.32936 9.33587C5.18009 8.75006 5.10059 8.1365 5.10059 7.50418C5.10059 7.49856 5.10059 7.49256 5.10059 7.48693C5.10284 6.57409 5.85029 5.83789 6.76313 5.83789H8.50818C8.93797 5.83789 9.28675 6.1863 9.28675 6.61647V8.55729C9.28675 8.98708 8.93834 9.33587 8.50818 9.33587H7.92162C8.42117 10.5829 9.41652 11.5782 10.6635 12.0778V11.4912C10.6635 11.0614 11.0119 10.7126 11.4421 10.7126H13.3829C13.8127 10.7126 14.1615 11.061 14.1615 11.4912L14.1622 11.492Z",
    fill: "#FFE585"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7667_3038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.343050ec603da4ba71bc2e8b5d041c65.svg";
export { ForwardRef as ReactComponent };